import { Icons } from '@ds/index'

import { SqlOperator } from '@/common/components/Table2/types'

export interface MeetingBookedData {
	rolling_scheduler_views_21d: string | null
	rolling_meetings_booked_21d: string | null
	rolling_meetings_from_table_21d: string | null
	booking_rate_21d: string | null
	meeting_table_booking_rate_21d: string | null
	submission_date: string
	form_ids: string[]
	submissions_count: string | null
	scheduler_views: string | null
	meetings_booked: string | null
	meetings_in_21d: string | null
}

export interface FormSubmissionsQueryParams {
	datePreset?: TimeFrame
	dateRange?: DateRange
	additionalFilters?: FilterState
}

export interface MeetingDataQueryParams {
	datePreset?: TimeFrame
	dateRange?: DateRange
	granularity?: Granularity
	memberIds?: string[]
}

export type WeekData = {
	week: string
	submissions: number
	startDate: string
	endDate: string
}

export enum Granularity {
	DAILY = 'daily',
	WEEKLY = 'weekly',
	MONTHLY = 'monthly',
}

export enum TimeFrame {
	LAST_7_DAYS = 'last_7_days',
	LAST_30_DAYS = 'last_30_days',
	LAST_90_DAYS = 'last_90_days',
}

export interface DateRange {
	startDate: Date
	endDate: Date
}

export interface TimeRange {
	start: Date
	end: Date
	label: string
}

export type MeetingData = {
	time_group: string
	meetings_created_count: number
	meetings_rescheduled_count: number
	meetings_cancelled_count: number
	average_time_to_meet_seconds: number | null
	median_time_to_meet_seconds: number | null
	p75_time_to_meet_seconds: number | null
	p90_time_to_meet_seconds: number | null
}

export type HeatmapData = {
	day_of_week: number
	meeting_hour: number
	meeting_count: number
}

export type MeetingsByMemberData = {
	time_group: string
	member_id: string
	average_time_to_meet_seconds: number
	member_name: string
	meetings_considered_for_average: number
}
// Define enums instead of string types
export enum ReportingFilterFieldEnum {
	UTM_NAME = 'utm_name',
	UTM_SOURCE = 'utm_source',
	UTM_TERM = 'utm_term',
	UTM_CONTENT = 'utm_content',
	UTM_MEDIUM = 'utm_medium',
	UTM_CAMPAIGN = 'utm_campaign',
	REFERRER = 'referrer',
	SUBMISSION_URL = 'submission_url',
	LANDING_URL = 'landing_url',
	LANDING_REFERRER = 'landing_referrer',
	FORM_ID = 'form_id',
}

export enum CategoryFieldEnum {
	UTM_CATEGORY = 'utm_category',
}

export type FilterField = ReportingFilterFieldEnum | CategoryFieldEnum

export interface FilterOperation {
	operator: SqlOperator
	value: string | string[] | null
}

export type FilterState = {
	[key in ReportingFilterFieldEnum]?: FilterOperation
}

export interface FilterCategory {
	field: FilterField
	label: string
	icon?: Icons
	isMultiple?: boolean
	children?: FilterCategory[]
	isCategory?: boolean
}

export interface UTMFiltersProps {
	onFiltersChange: (filters: FilterState) => void
}
